import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  border-radius: 9px;
  width: 100%;
  padding-bottom: 1rem;
  max-height: 50%;
  gap: 0.5rem;
`;

// HINTSTODO: uncomment this and delete above
// export const Wrapper = styled.div`
//   position: absolute;
//   bottom: 0;
//   left: 0;
//   width: 100%;
//   padding-right: 3rem;
//   padding-bottom: 1rem;
// `;

export const ErrorWrapper = styled.div`
  padding: 0 2rem;
  width: 100%;
`;
